import { QueryFunction, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";

// Extend the SprintQuery interface or its parts later if needed

type SprintQueryOptions<T> = Omit<UseQueryOptions<T>, "queryKey" | "queryFn">;

type SprintQueryKey = [
    string,
    ...(string | number | string[] | number[] | Record<string, string> | Record<string, number> | undefined)[]
];

interface SprintQueryParams<T> {
    queryKey: SprintQueryKey;
    queryFn: QueryFunction<T>;
    options?: SprintQueryOptions<T>;
    enabled?: boolean;
}

const defaultOptions: Omit<UseQueryOptions, "queryKey" | "queryFn"> = {
    refetchOnWindowFocus: false,
    refetchOnMount: false
};

export type SprintQueryResult<T> = UseQueryResult<T>;

export const useSprintQuery = <T>({
    queryFn,
    queryKey,
    options,
    enabled
}: SprintQueryParams<T>): SprintQueryResult<T> => {
    const queryOptions = {
        ...defaultOptions,
        ...options
    } as SprintQueryOptions<T>;

    return useQuery<T>({
        queryFn,
        queryKey,
        enabled,
        ...queryOptions
    });
};
